export const HTTP_RESPONSE_CODES = {
    SUCCESS: 200,
    CREATED: 201,
    BAD_REQUEST: 400,
    UNAUTHORIZED: 401,
    FORBIDDEN: 403,
    NOT_FOUND: 404,
    INTERNAL_SERVER_ERROR: 500,
};

export const APP_ENV = {
    STAGE: "STAGE",
    PROD: "PRODUCTION",
}

export const USER_TYPE = {
    CANDIDATE: "talent",
    EMPLOYER: "employer",
}

export const SEARCH_TYPE = {
    EMPLOYER: "employer",
    CANDIDATE: "candidate",
    CAMPAIGN: "campaign",
    CANDIDATE_TYPE: "candidateType",
}

export const SUPER_ADMIN = "SUPER_ADMIN";